import api from '@/core/api/client';

export type WhatsAppPricingCategory = 'marketing' | 'utility' | 'authentication';

export interface WhatsAppPricing {
  effectiveFrom: string;
  rates: Record<string, Record<WhatsAppPricingCategory, number>>;
}

export const whatsappPricingService = {
  async get(): Promise<WhatsAppPricing> {
    const res = await api.get<WhatsAppPricing>('/configuracoes/whatsapp-pricing');
    return res.data;
  },

  async import(file: File): Promise<WhatsAppPricing> {
    const fd = new FormData();
    fd.append('file', file);
    const res = await api.post<WhatsAppPricing>('/configuracoes/whatsapp-pricing/import', fd);
    return res.data;
  },
};
